import React from 'react';
import Icon from '../../../components/AppIcon';

const WalletBalance = ({ balance, monthlySubsidy, remainingCredits, renewalDate }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('es-MX', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })?.format(date);
  };

  const getDaysUntilRenewal = () => {
    const today = new Date();
    const renewal = new Date(renewalDate);
    const diffTime = renewal - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysLeft = getDaysUntilRenewal();
  const subsidyUsedPercentage = 75; // 75% used as shown in user's image

  return (
    <div className="bg-gradient-to-br from-emerald-500 via-green-500 to-teal-600 rounded-xl p-6 text-white shadow-xl">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
            <Icon name="Wallet" size={24} color="white" />
          </div>
          <div>
            <h2 className="font-heading font-bold text-xl">Billetera Universitaria</h2>
            <p className="text-white/90 text-sm">Universidad Panamericana</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-white/90 text-sm">Saldo Disponible</p>
          <p className="font-data font-bold text-3xl">{formatCurrency(balance)}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="bg-white/15 backdrop-blur-sm rounded-lg p-4 border border-white/20">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Gift" size={18} color="white" />
            <span className="text-sm font-medium">Subsidio Mensual</span>
          </div>
          <p className="font-data font-bold text-xl">{formatCurrency(monthlySubsidy)}</p>
          <p className="text-white/80 text-xs mt-1">Próximo: 15 Nov</p>
        </div>

        <div className="bg-white/15 backdrop-blur-sm rounded-lg p-4 border border-white/20">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="ShoppingBag" size={18} color="white" />
            <span className="text-sm font-medium">8 Bolsas este mes</span>
          </div>
          <p className="font-data font-bold text-xl">$320.00 Ahorrado este mes</p>
          
          <div className="mt-3 flex items-center justify-between">
            <span className="text-sm font-medium text-white">{subsidyUsedPercentage}%</span>
            <span className="text-sm font-medium text-white">Subsidio mensual usado</span>
          </div>
          <div className="w-full bg-white/30 rounded-full h-2 mt-1">
            <div 
              className="bg-white h-2 rounded-full transition-all duration-300" 
              style={{ width: `${subsidyUsedPercentage}%` }}
            ></div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <button className="bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 text-white font-medium py-2 px-4 rounded-lg transition-all duration-200">
          Ver billetera
        </button>
        <div className="text-right">
          <p className="text-white/90 text-sm">Próxima Renovación</p>
          <p className="font-data font-bold text-lg">{daysLeft} días</p>
        </div>
      </div>

      <div className="mt-4 p-3 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
        <div className="flex items-center space-x-2">
          <Icon name="Info" size={16} color="white" />
          <span className="text-sm text-white/90">
            Los créditos no utilizados expiran el {formatDate(renewalDate)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default WalletBalance;